export interface ChatMember {
  ///  The Identity server ID of the user
  id: string;
  /// The identity server user name
  identityUserName: string;
  /// First + Last name of the user
  displayName: string;
}
